import type * as lazyIndex from "./lazyIndex";
import { LazyAction, type LazyComponent, LazyModule, createLazyComponent } from "owa-bundling";

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule(() => import(/* webpackChunkName: "MailModuleKeys"*/ "./lazyIndex"), { name: "MailModuleKeys" });
export const lazySetupMailModuleKeys: LazyAction<typeof lazyIndex.setupMailModuleKeys, typeof lazyModule> = new LazyAction(lazyModule, m => m.setupMailModuleKeys);
export const GroupView: LazyComponent<{}, unknown, void> = createLazyComponent(lazyModule, m => m.GroupView);
